'use client'
import React from 'react'
import { Card } from './Card'
import { File, TextTypes } from '../../../types'
import { Text } from '../Text'
import { Button, ButtonVariants } from '../Button'
import { DownloadIcon, ExportIcon } from '../../icons'

interface FileCardProps extends React.HTMLAttributes<HTMLDivElement> {
    file: File
}

export const FileCard = ({ file, ...props }: FileCardProps): JSX.Element => {
    if (!file?.url) return <></>

    return (
        <Card
            {...props}
            className={`flex items-center ${props.className ?? ''}`}
            dense
            actions={
                <>
                    <a href={file.url} target="_blank">
                        <Button variant={ButtonVariants.QUIET} icon={<ExportIcon />} />
                    </a>
                    <a href={file.url}>
                        <Button variant={ButtonVariants.QUIET} icon={<DownloadIcon />} />
                    </a>
                </>
            }
        >
            <a href={file.url} target="_blank">
                <Text type={TextTypes.LINK}>{file.name ?? file.url}</Text>
            </a>
        </Card>
    )
}
